/* eslint-disable unicorn/error-message */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-extraneous-class */
/* eslint-disable no-console */
export class Logger {
  private static timestamp(): string {
    const now = new Date();
    const time = now.toLocaleTimeString();
    const date = now.toLocaleDateString();
    return `[${date} ${time}]`;
  }

  static log(message?: unknown, ...optionalParameters: unknown[]): void {
    console.log(`${Logger.timestamp()}: [LOG] ${message}`, ...optionalParameters);
  }

  static error(message?: unknown, ...optionalParameters: unknown[]): void {
    let stack = new Error().stack;

    if (message instanceof Error) {
      stack = message.stack;
    }

    console.error(`${Logger.timestamp()}: [ERROR] ${message}`, ...optionalParameters, stack);
  }

  static info(message?: unknown, ...optionalParameters: unknown[]): void {
    console.info(`${Logger.timestamp()}: [INFO] ${message}`, ...optionalParameters);
  }

  static warn(message?: unknown, ...optionalParameters: unknown[]): void {
    console.warn(`${Logger.timestamp()}: [WARN] ${message}`, ...optionalParameters);
  }

  static debug(message?: unknown, ...optionalParameters: unknown[]): void {
    const stack = new Error().stack;

    console.debug(`${Logger.timestamp()}: [DEBUG] ${message}`, ...optionalParameters, stack);
  }

  static trace(message?: unknown, ...optionalParameters: unknown[]): void {
    const stack = new Error().stack;

    console.trace(`${Logger.timestamp()}: [TRACE] ${message}`, ...optionalParameters, stack);
  }

  static time(label: string): void {
    console.time(label);
  }

  static timeEnd(label: string): void {
    console.timeEnd(label);
  }
}
